import { Booking, Metadata } from '@deliveries-app/models';
import { BookingActions, BookingActionTypes } from './actionTypes';

export interface BookingsReducerState {
  loading: boolean;
  message: string;
  error: string;
  errors: string[];
  _metadata: Metadata;
  bookings: Booking[];
}

const initialState: BookingsReducerState = {
  loading: false,
  message: '',
  error: '',
  errors: [],
  _metadata: {
    page: 1,
    perPage: 0,
    total: 0,
    pages: 0,
  },
  bookings: [],
};

export default function bookingsReducer(
  state = initialState,
  action: BookingActions
) {
  switch (action.type) {
    case BookingActionTypes.BOOKING_REQUEST:
      return {
        ...state,
        loading: true,
        message: BookingActionTypes.BOOKING_REQUEST,
        errors: [],
      };
    case BookingActionTypes.GET_ALL_BOOKINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        bookings: action.payload.data,
        _metadata: action.payload._metadata,
        message: BookingActionTypes.GET_ALL_BOOKINGS_SUCCESS,
        error: '',
      };
    case BookingActionTypes.GET_ALL_BOOKINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: BookingActionTypes.GET_ALL_BOOKINGS_FAILURE,
      };
    case BookingActionTypes.CREATE_BOOKING_SUCCESS:
      return {
        ...state,
        loading: false,
        bookings: [...state.bookings, action.payload],
        message: BookingActionTypes.CREATE_BOOKING_SUCCESS,
        error: '',
      };
    case BookingActionTypes.CREATE_BOOKING_FAILURE:
      console.log(action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        errors: action.payload.errors,
        message: BookingActionTypes.CREATE_BOOKING_FAILURE,
      };
    case BookingActionTypes.UPDATE_BOOKING_SUCCESS:
      return {
        ...state,
        loading: false,
        bookings: state.bookings.map((booking) => {
          if (booking.id === action.payload.id) {
            return action.payload;
          }
          return booking;
        }),
        error: '',
        message: BookingActionTypes.UPDATE_BOOKING_SUCCESS,
      };
    case BookingActionTypes.UPDATE_BOOKING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        errors: action.payload.errors,
        message: BookingActionTypes.UPDATE_BOOKING_FAILURE,
      };
    case BookingActionTypes.DELETE_BOOKING_SUCCESS:
      return {
        ...state,
        loading: false,
        bookings: state.bookings.filter(
          (booking) => booking.id !== action.payload
        ),
        error: '',
        message: BookingActionTypes.DELETE_BOOKING_SUCCESS,
      };
    case BookingActionTypes.DELETE_BOOKING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: BookingActionTypes.DELETE_BOOKING_FAILURE,
      };
    case BookingActionTypes.CREATE_BOOKING_NOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        bookings: state.bookings.map((booking) => {
          if (booking.id === action.payload.booking_id) {
            return {
              ...booking,
              notes: [...booking.notes, action.payload.note],
            };
          }
          return booking;
        }),
        error: '',
        message: BookingActionTypes.CREATE_BOOKING_NOTE_SUCCESS,
      };
    case BookingActionTypes.CREATE_BOOKING_NOTE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: BookingActionTypes.CREATE_BOOKING_NOTE_FAILURE,
      };
    default:
      return state;
  }
}
